import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import Grid from "@material-ui/core/Grid"

import { Avatar } from "@progress/kendo-react-layout"
import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout"

import GoogleSignOn from "../GoogleSignOn/GoogleSignOn"

function CustomDrawerItem(props) {
  const { icon, text, disabled, children, user, appMode } = props

  const parentProps = { ...props }
  delete parentProps.user

  if (!children) {
    return (
      <DrawerItem {...parentProps}>
        <Grid container>
          {icon && (
            <Grid item style={{ paddingRight: "0.5rem" }}>
              <span className={icon} />
            </Grid>
          )}

          <Grid item>
            {!disabled && <p>{text}</p>}
            {disabled && (
              <p style={{ fontSize: "0.75rem", textAlign: "center" }}>
                {text}
                {user ? ` - Logged as ${user?.attributes?.name} (${user?.attributes.email})` : ""}
              </p>
            )}
          </Grid>
        </Grid>
      </DrawerItem>
    )
  } else {
    return children
  }
}

function DrawerContainer(props) {
  const materialUiTheme = useTheme()
  const sm = useMediaQuery(materialUiTheme.breakpoints.down("sm"))

  const location = useLocation()
  const history = useHistory()

  const { onExpand, children, user } = props

  // prettier-ignore
  const drawerItems = [
        user && sm ? {
            children: (
                <Grid
                    container
                    alignContent='center'
                    alignItems='center'
                    style={{ height: '3rem', backgroundColor: '#3f51b5' }}
                >
                    <Grid item style={{ paddingRight: '1rem', paddingLeft: '1rem' }}>
                        <GoogleSignOn
                            {...props}
                            disableResize={true}
                            closeDrawer={() => setExpanded((prev) => !prev)}
                            dark={true}
                        />
                    </Grid>

                    <Grid item style={{ flexGrow: 1 }} />

                    <Grid item style={{ paddingRight: '1rem' }}>
                        {user?.profilePictureUrl && (
                            <Avatar type="image" shape="circle" themeColor="inherit">
                                <img src={user?.profilePictureUrl} alt="User profile" />
                            </Avatar>
                        )}
                    </Grid>
                </Grid>
            ),
        } : {},

        {
            text: 'Inbox',
            selected: true,
            route: '/',
            icon: 'fas fa-inbox',
        },
        {
          text: 'Manage Users',
          selected: true,
          route: '/manage',
          icon: 'fas fa-users-cog',
      },
      {
        text: 'Nominate Officers',
        selected: true,
        route: '/nominateofficers',
        icon: 'fas fa-people-arrows',
    },
      {
        text: 'Send Request',
        selected: true,
        route: '/sendrequest',
        icon: 'fas fa-paper-plane',
    },
    //     {
    //         text: 'Feedback',
    //         route: '/feedback',
    //         icon: 'fas fa-comments',
    //     },
        {
            text:
                'InD - BIDs User Portal ' +
                `${process.env.REACT_APP_SENTRY_VERSION} (${process.env.REACT_APP_SENTRY_ENVIRONMENT})`,
            disabled: true,
        },
    ];

  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    onExpand({
      do: () => {
        setExpanded((prev) => !prev)
      },
    })
  }, [])

  const onSelectHandler = (event) => {
    history.push(event.itemTarget.props.route)

    setExpanded((prev) => !prev)
  }

  const setSelectedItem = (pathname) => {
    const currentPath = drawerItems.find(
      (drawerItem) => drawerItem.route === `/${pathname.split("/")[1]}`
    )

    if (currentPath?.text) {
      return currentPath.text
    }
  }

  const selected = setSelectedItem(location.pathname)

  return (
    <Drawer
      expanded={expanded}
      mode={"overlay"}
      width={256}
      item={(itemRenderProps) => {
        return <CustomDrawerItem {...itemRenderProps} user={user} />
      }}
      items={drawerItems
        .filter(
          (drawerItem) =>
            drawerItem.text || drawerItem.separator || drawerItem.children
        )
        .map((drawerItem) => ({
          ...drawerItem,
          selected: drawerItem.text === selected,
        }))}
      onSelect={onSelectHandler}
      onOverlayClick={() => {
        setExpanded((prev) => !prev)
      }}
      animation={false}
    >
      <DrawerContent>{children}</DrawerContent>
    </Drawer>
  )
}

export default DrawerContainer
